var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M3407.5,12831.221a7,7,0,1,1,7,6.779A6.9,6.9,0,0,1,3407.5,12831.221Zm1.447,0a5.554,5.554,0,1,0,5.553-5.412A5.49,5.49,0,0,0,3408.948,12831.221Zm3.88,1.09a.686.686,0,1,1,0-1.37h.949v-2.565a.724.724,0,0,1,1.447,0v3.249a.7.7,0,0,1-.722.687Zm-.837-8.938a.687.687,0,1,1,0-1.372h5.018a.687.687,0,1,1,0,1.372Z",
    transform: "translate(-3407.501 -12822)",
    fill: "#909aac"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTime);
export default __webpack_public_path__ + "static/media/service_time.51786add8ff63cbba9ac670c57195c2e.svg";
export { ForwardRef as ReactComponent };